import React from 'react';

interface MultilineTextBoxProps {
  label?: string;
  value: string;
  required?: boolean;
  disabled?: boolean;
  rows?: number;
  onChange: (value: string) => void;
}

const MultilineTextBox: React.FC<MultilineTextBoxProps> = ({ label, value, required, disabled, rows = 3, onChange }) => (
  <div className="mb-3">
    {label && <label className="form-label">{label}{required && ' *'}</label>}
    <textarea
      className="form-control"
      value={value}
      required={required}
      disabled={disabled}
      rows={rows}
      onChange={e => onChange(e.target.value)}
      style={{ resize: 'vertical' }}
    />
  </div>
);

export default MultilineTextBox;
